var _rect, _path, _line, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.781,
    y: 13.103,
    width: 32.439,
    height: 9.63,
    rx: 1.439,
    ry: 1.439
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.634,22.733h26.733v14.709c0,.794-.645,1.439-1.439,1.439H9.073c-.794,0-1.439-.645-1.439-1.439v-14.709h0Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 13.103,
    x2: 21,
    y2: 38.881
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m20.939,11.606l-7.166-1.266c-2.663-.47-3.901-3.579-2.289-5.751h0c1.612-2.172,4.946-1.888,6.168.525l3.287,6.492Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21.061,11.606l7.166-1.266c2.663-.47,3.901-3.579,2.289-5.751h0c-1.612-2.172-4.946-1.888-6.168.525l-3.287,6.492Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorGift);
export default __webpack_public_path__ + "static/media/indoor-gift.33737e97528c7024ff30e945fc8dae68.svg";
export { ForwardRef as ReactComponent };